import { gql } from '@apollo/client'
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core'

import { CalculateLivePremiumQuotesFragmentDoc } from './CalculateLivePremiumQuotes.generated'
import * as Types from './purchasePlus_graphql'

export const BestBuyItemPricesFragmentDoc = gql`
  fragment BestBuyItemPrices on Price {
    ...CalculateLivePremiumQuotes
  }
  ${CalculateLivePremiumQuotesFragmentDoc}
` as unknown as DocumentNode<Types.BestBuyItemPricesFragment, unknown>
